<template>
<div>
  <ChatAppBar> T{{$route.params.type.charAt(0).toUpperCase()}}P{{$route.params.id}} Chat </ChatAppBar>
  <div class="page-content header-clear-small ">
    <ul class="messages " id="msg" v-chat-scroll="{always: false, smooth: true}">
      <div class="message"  v-for="message in messages" :key="message.id" :class="generateClass( message )" role="alert">
        <h4 class="color-white">{{ message.message }}</h4>
        <strong class="alert-icon-text">{{ message.user.id == user.id ? "me" : message.user.name }} {{timeFromDate(message.created_at)}}</strong>
        <span :class="generateClassAlert(message)"><i :class=" message.user.id == user.id ? 'fa fa-check font-18' : 'fa fa-inbox font-18'"></i></span>
      </div>
    </ul>
    <br>
    <br>
  </div>

    <div class="row send-message color-theme color">
      <div class="col-10 ">
      
        <div class="input-style has-icon input-style-1 input-required pb-1 message-edit">
          <input v-model="message" v-on:keyup.enter="sendMessage" placeholder="Type your message" type="text">
        </div>
      </div>
      <div class="col-2 message-edit">
        <span v-if="!loading" @click="sendMessage" :disabled="!message.length" 
              class="alert-icon color-white"><i class="fa fa-paper-plane font-18"></i>
        </span>
      </div>
    </div>
  <FooterBar></FooterBar>
</div>
</template>

<script>
import FooterBar from "@/components/FooterBar";
import axios from "axios";
import global from "@/mixins/global";
import ChatAppBar from "@/components/ChatAppBar";
import {mapMutations} from "vuex"

export default {
  mixins: [global],
  data(){
    return {
      checking: null,
    }
  },
  beforeDestroy() {
    clearInterval(this.checking)
  },
  created() {
    this.updateMessages([])
    this.fetchMessages()
    this.checking =  setInterval(this.fetchMessages, 10000)
  },
  name: "ChatMessages",
  components: {ChatAppBar, FooterBar},
  methods: {
    ...mapMutations(["updateMessages"]),
    scrollMessages(){
      var container = this.$el.querySelector("#msg");
      container.scrollTop = container.scrollHeight;
    },
    fetchMessages(){
      axios.get(this.base_url+this.$route.params.type+"/messages/"+this.$route.params.id,
          this.requestAuthHeaderToken(localStorage.getItem("token"))).then(
          response=>{
            // this.messages = response
            this.updateMessages(response.data.data.reverse())
            this.scrollMessages()
          }).catch(error=>{this.error = error})
    },
    sendMessage(){
      this.loading = true
      let data = {
        "message":this.message
      }
      if(this.$route.params.type === "stands"){
        data.stand_id = this.$route.params.id
      }else if(this.$route.params.type === "investments"){
        data.investment_id = this.$route.params.id
      }
      else if(this.$route.params.type === "rounds"){
        data.round_id = this.$route.params.id
      }
      else{
        data.farming_id = this.$route.params.id
      }
      axios.post( this.base_url+this.$route.params.type+"/messages", data, this.requestAuthHeaderToken(localStorage.getItem("token"))).then(()=>{
        this.loading = false
        this.message = ""
        this.fetchMessages()
        this.scrollMessages()
      })
    },

  },
  computed: {
    stateuser(){
      return this.$store.getters.user
    },
    messages(){
      return this.$store.getters.messages
    }
  }
  
}


</script>

<style scoped>
  .message-sent{
    
    margin: 10px 15px 10px 30px;
    border-radius:8px 8px 0px 8px;
  }
  .message-received{
    margin: 10px 30px 10px -25px;
    border-radius:8px 8px 8px 0px;
  }

  .alert-sent{
    left: -1px;
  }

  .alert-received{
    right: -1px;
  }

  .fa-paper-plane{
    padding: 15px 20px 15px 1px;
    color: white;
  }

  .send-message{
    position: fixed;
    bottom: 18px;
    background-color: #127502;
    left: 0;
    right: 0;
    min-height: 60px;
  }

  .input-style{
    color: white;
  }

  .text-white{
    color: white;
  }
  ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  font-size: 15px!important;
  color:#fff
}
::-moz-placeholder { /* Firefox 19+ */
   font-size: 15px!important;
   color:#fff
}
:-ms-input-placeholder { /* IE 10+ */
   font-size: 15px!important;
   color:#fff
}
:-moz-placeholder { /* Firefox 18- */
   font-size: 15px!important;
   color:#fff
}
.message-edit{
  background-color:#545775;
  font-size: 2rem;
  
}
.color{
   background-color:#545775;
}
.message-box{
  background-color: #545775;
}
.message{
  background-color: #545775!important;
}

</style>